import styles from "./SpecialOffersListItem.module.scss";
import ArrowRight from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ArrowRight24PxOutlined";
import { categoriseMessages, formatTagsForDisplay } from "../../utils";
import {
  NonPromotionalMessage,
  PromotionalMessage,
} from "../../../../types/prodcatBaseTypes";
import { ListItem } from "../../../__shared__/ListItem/ListItem";
import { SaleTagIcon } from "../../../__shared__/SaleTagIcon/SaleTagIcon";

type Props = {
  promotions: (NonPromotionalMessage | PromotionalMessage)[];
  onClick: () => void;
  isNewPromoListItem: boolean;
};

export const SpecialOffersListItem = ({
  promotions,
  onClick,
  isNewPromoListItem = false,
}: Props) => {
  if (isNewPromoListItem) {
    const messagesWithCategoryAndType = categoriseMessages(promotions);
    const customerFacingTags = formatTagsForDisplay(
      messagesWithCategoryAndType,
    );
    const listItemContent = (
      <>
        <div className={styles.tagGroups}>
          {customerFacingTags.offers.length ? (
            <div className={styles.tagGroup}>
              {customerFacingTags.offers.map((tag, idx) => (
                <div className={styles.tagBadge} key={idx}>
                  <SaleTagIcon size="small" />
                  {tag}
                </div>
              ))}
            </div>
          ) : null}
          {customerFacingTags.claims.length ? (
            <div className={styles.tagGroup}>
              {customerFacingTags.claims.map((tag, idx) => (
                <div className={styles.tagBadge} key={idx}>
                  {tag}
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </>
    );

    return (
      <ListItem
        label={listItemContent}
        trailingIcon={<ArrowRight />}
        onClick={onClick}
        showTopBorder
        showBottomBorder
        aria-label="special offers"
        className={styles.tagListItem}
      />
    );
  } else {
    return (
      <ListItem
        trailingIcon={<ArrowRight />}
        onClick={onClick}
        label={
          promotions.length === 1
            ? "Special offer"
            : `Special offers (${promotions.length})`
        }
        data-testid="special-offers-drawer-header"
        showTopBorder={false}
        showBottomBorder={false}
        isOffer
      />
    );
  }
};
